export default __webpack_public_path__ + "static/media/1.29451902.png";